<div class="db-plan-period-switch">
  @if (forDemo) {
    <div class="upgrade__switch">
      <label class="db-fc-switch sl-enable-scheduling-demo">
        <span class="db-annual-text"
          [ngClass]="{'db-inactive': toggled}">Annual discount (50%)</span>
        <div class="db-switch">
          <input class="db-switch__input db-monthly" type="radio" name="db-switch__input" [formControl]="switch"
                 [value]="1" (click)="onSwitch()" [checked]="switch.value === 1 ? 'checked' : ''" *ngIf="!toggled">
          <input class="db-switch__input db-yearly" type="radio" name="db-switch__input" [formControl]="switch"
                 [value]="12" (click)="onSwitch()" [checked]="switch.value === 12 ? '' : 'checked'" *ngIf="toggled">
          <span class="db-switch__bg {{switcherColor}}" [ngClass]="{'new': newPrice,
            'small': small && !isMobile,
            'new-mobile':
            isMobile}">
                <span class="db-switch__head" [ngClass]="{'toggled': toggled, 'small': small}"></span>
            {{ toggled }}
              </span>
        </div>
      </label>
    </div>
  }@else {
    <div class="upgrade__switch" [ngClass]="{'small': small}" *ngIf="!isEcommerceWebsite; else ecommercePeriodSwitcher">
      <label class="db-fc-switch sl-enable-scheduling-switch">
        <div class="db-monthly">
        <span
          [ngClass]="{'db-inactive': !toggled, 'db-new-price': newPrice, 'db-bold': !newPrice && !isMobile && (currentSubscription?.trialClient || currentSubscription.type === UserSubscriptionType.PLATFORM)}">{{ ((currentSubscription?.boosterProClient || currentSubscription?.trialBoosterClient) && boosterPro) ? 'Billed Monthly' : (!!uppercaseTitle ? 'MONTHLY' : 'Monthly') }}</span>
          <div
            class="db-save-lifetime {{currentSubscription?.trialClient || currentSubscription.type === UserSubscriptionType.PLATFORM ? 'db-blue' : 'db-green'}}"
            [ngClass]="{'db-inactive': !toggled}" *ngIf="limitedTimeOffer"></div>
        </div>
        <div class="db-switch">
          <input class="db-switch__input db-monthly" type="radio" name="db-switch__input" [formControl]="switch"
                 [value]="1" (click)="onSwitch()" [checked]="switch.value === 1 ? 'checked' : ''" *ngIf="!toggled">
          <input class="db-switch__input db-yearly" type="radio" name="db-switch__input" [formControl]="switch"
                 [value]="12" (click)="onSwitch()" [checked]="switch.value === 12 ? '' : 'checked'" *ngIf="toggled">
          <span class="db-switch__bg {{switcherColor}}" [ngClass]="{'new': newPrice,
            'small': small && !isMobile,
            'new-mobile':
            isMobile}">
                <span class="db-switch__head" [ngClass]="{'toggled': toggled, 'small': small}"></span>
            {{ toggled }}
              </span>
        </div>
        <div class="db-annual"
             [ngClass]="{'db-limited-offer': limitedTimeOffer, 'db-with-save-thirty': newPrice || isMobile}">
            <span
              [ngClass]="{'db-inactive': toggled, 'db-new-price': newPrice, 'db-bold': !newPrice && !isMobile && (currentSubscription?.trialClient || currentSubscription.type === UserSubscriptionType.PLATFORM)}">{{
                ((currentSubscription?.boosterProClient ||
                  currentSubscription?.trialBoosterClient || user?.oneProductOrBundleClient) && boosterPro) ? 'Billed Annually' : (!!uppercaseTitle ? 'ANNUAL' : 'Annual')
              }}</span>
          <div class="db-best-value {{switcherColor}}" *ngIf="(currentSubscription?.trialBoosterClient ||
            currentSubscription?.boosterProClient || user?.oneProductOrBundleClient) && boosterPro">
            <span>Save 60%</span></div>
          <div class="db-best-value db-blue"
               *ngIf="(currentSubscription?.trialClient || currentSubscription.type === UserSubscriptionType.PLATFORM) && !newPrice && !isMobile && !hideBadge">
            <span>Save 50%</span></div>
          <span class="db-save-fifty" *ngIf="newPrice || isMobile">save up to 50%</span>
        </div>
      </label>
    </div>
  }
</div>

<ng-template #ecommercePeriodSwitcher>
  <div class="upgrade__switch-ecommerce">
    <span>Save up to 30%<br><span>with Annual</span></span>
    <label class="db-fc-switch sl-enable-scheduling-switch">
      <div class="db-annual"
           [ngClass]="{'active': switch.value === 12}">
            <span>Annual</span>
      </div>
      <div class="db-monthly"
           [ngClass]="{'active': switch.value === 1}">
        <span>{{'text_periodMonthly' | dbText}}</span>
      </div>
      <div class="db-switch">
        <input class="db-switch__input db-monthly" type="radio" name="db-switch__input" [formControl]="switch"
               [value]="1" (click)="onSwitch()" [checked]="switch.value === 1 ? 'checked' : ''" *ngIf="!toggled">
        <input class="db-switch__input db-yearly" type="radio" name="db-switch__input" [formControl]="switch"
               [value]="12" (click)="onSwitch()" [checked]="switch.value === 12 ? '' : 'checked'" *ngIf="toggled">
        <span class="db-switch__bg {{switcherColor}}" [ngClass]="{'new': newPrice,
            'small': small && !isMobile,
            'new-mobile':
            isMobile}">
                <span class="db-switch__head" [ngClass]="{'toggled': toggled, 'small': small}"></span>
          {{ toggled }}
              </span>
      </div>
    </label>
  </div>
</ng-template>
